import { createRouter, createWebHistory } from "vue-router";
import api from "@/api";

import ViewHome from "../components/HomePage.vue";
import ViewUs from "../components/UsPage.vue";
import ViewContact from "../components/ContactPage.vue";
import ViewServices from "../components/ServicePage.vue";
import ViewOnibi from "../components/OnibiPage.vue";
import ViewCatalog from "../components/CatalogPage.vue";
import Print3DPage from "../components/Print3DPage.vue";
import Print3DCatalogPage from "../components/Print3DCatalogPage.vue";
import PrivacyPage from "../components/Legal/PrivacyPage.vue";
import TermsPage from "../components/Legal/TermsPage.vue";
import AdminPage from "../components/AdminPage.vue";
import loginPage from "../components/loginPage.vue";
import RecoverRequestPage from "../components/RecoverRequestPage.vue";
import RecoverPasswordPage from "../components/RecoverPasswordPage.vue";
import Mindset from "../components/PersonalHub/MindsetPage.vue";
import GastosPage from "@/components/GastosPage.vue";
import IngresosPage from "@/components/IngresosPage.vue";
import DashboardPage from "@/components/DashboardPage.vue";
import Print3DMaterialesPage from "@/components/Print3DAdmin/Print3DMaterialesPage.vue";
import Print3DCatalogoPage from "@/components/Print3DAdmin/Print3DCatalogoPage.vue";
import Print3DCategoriasPage from "@/components/Print3DAdmin/Print3DCategoriasPage.vue";
import Print3DOrdenesPage from "@/components/Print3DAdmin/Print3DOrdenesPage.vue";

const DEFAULT_DESCRIPTION = 'Selk trabaja en tres áreas: impresión 3D, automatización de procesos y aplicativos web a la medida de tu negocio.';

const routes = [
    {path: '/',name: 'Home', component: ViewHome, meta: { title: 'Selk — Impresión 3D, automatización y aplicativos web', description: 'Fabricamos tus piezas con impresión 3D, automatizamos tus procesos y construimos el software que los sostiene. Soluciones a la medida para empresas, emprendedores y estudiantes.' }},
    {path: '/us',name: 'Us', component: ViewUs, meta: { title: 'Nosotros | Selk', description: 'Conoce a Selk: un grupo de ingenieros que integra el desarrollo de software empresarial y la fabricación 3D para resolver desafíos reales.' }},
    {path: '/us/Fabian',name: 'Fabian', component: Mindset},
    {path: '/contact',name: 'Contact', component: ViewContact, meta: { title: 'Contacto | Selk', description: 'Hablemos de tu proyecto. Solicita tu cotización de aplicativos web, automatización o impresión 3D. Te respondemos rápido.' }},
    {path: '/services',name: 'Services', component: ViewServices, meta: { title: 'Servicios | Selk', description: 'Nuestras tres áreas: impresión 3D, automatización de procesos y aplicativos web. Conoce qué resuelve cada una y cómo trabajamos.' }},
    {path: '/onibi',name: 'Onibi', component: ViewOnibi, meta: { title: 'Onibi | Selk', description: 'Onibi: el control inteligente de tus espacios. Próximamente.' }},
    {path: '/catalog',name: 'Catalog', component: ViewCatalog, meta: { title: 'Catálogo | Selk', description: 'Explora nuestras creaciones: piezas fabricadas en 3D, automatizaciones a medida y aplicativos web.' }},
    {path: '/print3d',name: 'Print3D', component: Print3DPage, meta: { title: 'Impresión 3D bajo demanda | Selk', description: 'Cotiza tu impresión 3D y solicita el modelado de piezas a medida. Del archivo a la pieza real.' }},
    {path: '/print3d/catalogo',name: 'Print3DCatalog', component: Print3DCatalogPage, meta: { title: 'Catálogo completo de impresión 3D | Selk', description: 'Todas nuestras piezas impresas en 3D, agrupadas por categoría. Busca por nombre, filtra por familia de producto y pide la tuya.' }},
    {path: '/privacidad',name: 'Privacy', component: PrivacyPage, meta: { title: 'Política de privacidad | Selk', description: 'Cómo tratamos tus datos personales y los archivos que compartes con Selk, y cómo ejercer tus derechos como titular.' }},
    {path: '/terminos',name: 'Terms', component: TermsPage, meta: { title: 'Términos y condiciones | Selk', description: 'Condiciones de uso del sitio, de las cotizaciones y de los servicios de Selk.' }},
    {path: '/admin',name: 'Admin', component: AdminPage, meta: { requiresAuth: true, layout: 'admin', title: 'Panel administrativo' }},
    {path: '/login',name: 'Login', component: loginPage, meta: { layout: 'auth', title: 'Acceso al panel | Selk' }},
    {path: '/recover/request', name: 'RecoverRequest', component: RecoverRequestPage, meta: { layout: 'auth', title: 'Recuperar contraseña | Selk' }},
    {path: '/recover/:token', name: 'RecoverPassword', component: RecoverPasswordPage, meta: { layout: 'auth', title: 'Nueva contraseña | Selk' }},
    {path: '/gastos',name: 'Gastos', component: GastosPage, meta: { requiresAuth: true, layout: 'admin', title: 'Gastos' }},
    {path: '/ingresos',name: 'Ingresos', component: IngresosPage, meta: { requiresAuth: true, layout: 'admin', title: 'Ingresos' }},
    {path: '/dashboard',name: 'Dashboard', component: DashboardPage, meta: { requiresAuth: true, layout: 'admin', title: 'Dashboard' }},
    {path: '/admin/print3d/materiales', name: 'Print3DMateriales', component: Print3DMaterialesPage, meta: { requiresAuth: true, layout: 'admin', title: 'Materiales de Impresión 3D' }},
    {path: '/admin/print3d/categorias', name: 'Print3DCategorias', component: Print3DCategoriasPage, meta: { requiresAuth: true, layout: 'admin', title: 'Categorías del catálogo' }},
    {path: '/admin/print3d/catalogo', name: 'Print3DCatalogo', component: Print3DCatalogoPage, meta: { requiresAuth: true, layout: 'admin', title: 'Catálogo de productos 3D' }},
    {path: '/admin/print3d/ordenes', name: 'Print3DOrdenes', component: Print3DOrdenesPage, meta: { requiresAuth: true, layout: 'admin', title: 'Bandeja de solicitudes 3D' }},
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth' 
      }
    }
    return { top: 0 }
  }
});

router.afterEach((to) => {
  const baseTitle = 'Selk';
  // Las vistas públicas traen el título completo ("Nosotros | Selk"); las
  // administrativas guardan sólo la etiqueta, porque la topbar la reutiliza
  // como encabezado de pantalla (plan 27_09_2026 §4.2).
  document.title = to.meta?.layout === 'admin'
    ? `${to.meta.title} | ${baseTitle}`
    : (to.meta?.title || baseTitle);

  const description = to.meta?.description || DEFAULT_DESCRIPTION;
  let descTag = document.querySelector('meta[name="description"]');
  if (!descTag) {
    descTag = document.createElement('meta');
    descTag.setAttribute('name', 'description');
    document.head.appendChild(descTag);
  }
  descTag.setAttribute('content', description);
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    try {
      const response = await api.get("/verify");
      if (response.status === 200) {
        next();
      } else {
        next("/admin");
      }
    } catch (err) {
      console.error("No autorizado:", err);
      next("/login");
    }
  } else {
    next();
  }
});

export default router;